import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth.jsx";
import { useI18n } from "../lib/i18n.jsx";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  const { t } = useI18n();
  if (user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="font-display text-2xl text-[#4A4238] italic">{t("common.loading")}</div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/diary" replace />;
  }
  return children;
}
